import { DataFile } from '../types/data-file-interface'
import {
  WebsiteFontSettingsInterface,
  WebsiteStylesInterface,
} from '../types/website-settings-types'

const pickAllTypographySlots = (websiteStyles?: WebsiteStylesInterface) => [
  websiteStyles?.formFields?.typography,
  websiteStyles?.buttonsAndLinks?.primary?.typography,
  websiteStyles?.buttonsAndLinks?.secondary?.typography,
  websiteStyles?.typography?.heading,
  websiteStyles?.typography?.paragraph,
]

const pickTypography = (typography?: WebsiteFontSettingsInterface) =>
  typography?.fontFamily
    ? {
        fontFamily: typography.fontFamily,
        fontFileId: typography?.fontFileId || typography?.fontFile?.id,
        fontWeight: typography.fontWeight as string,
        fontStyle: typography.fontStyle as string,
      }
    : null

export const pickWebsiteStylesAllTypography = (
  websiteStyles?: WebsiteStylesInterface,
) =>
  pickAllTypographySlots(websiteStyles)
    .map(pickTypography)
    .filter(typography => typography !== null)

export const pickWebsiteStylesAllFontFiles = (
  websiteStyles?: WebsiteStylesInterface,
): DataFile[] =>
  pickAllTypographySlots(websiteStyles)
    .map(typography => typography?.fontFile)
    .filter((file): file is DataFile => Boolean(file))
